import React, {Fragment} from 'react';
import { inject, observer } from 'mobx-react';
import { withFirebase } from '../../../services/Firebase';
import classnames from "classnames";
import "../../../assets/scss/pages/common.scss";
import ScheduleMeetingWizard from "../../calendar/components/ScheduleMeetingWizard";

import { Card, Col, CardHeader, CardTitle, CardBody, Button } from 'reactstrap';
import { MoreHorizontal, UserPlus, Plus, Calendar, ChevronLeft, ChevronRight, Circle } from "react-feather"
import "../../../assets/scss/pages/app-chat.scss";
import { Link } from 'react-router-dom';

import img1 from "../../../assets/img/portrait/small/avatar-s-5.jpg"

const day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var month = [
	"January", "February", "March", "April", "May", "June", "July",
	"August", "September", "October", "November", "December"
];

@inject('sessionStore', 'dashboardStore')
@observer
class MeetingCard extends React.Component {

	state={
		sliderVisibility: false,
		dateBeforePreviousDate: "",
		previousDate: "",
		selectedDate : "",
		nextDate: "",
		dateAfterNextDate: "",
		meetingUid: ""
	}

	componentDidMount() {
		let { dashboardStore, sessionStore } = this.props;
		let { authUser } = sessionStore;
		const today = new Date();
		this.modifyDates(today);
		// userStore.loadMeetings(firebase, authUser.uid);
		dashboardStore.fetchMeetings(authUser.uid, today);
	}

	componentWillUnmount() {
		//this.props.firebase.meetings().off();
	}

	toggleSlider = () => {
		this.setState(prevState => ({
			sliderVisibility: !prevState.sliderVisibility
		}))
	}

	modifyDates = (date) => {
		const selectedDate = date;
    const dateBeforePreviousDate = new Date(selectedDate);
    const previousDate = new Date(selectedDate);
    const nextDate = new Date(selectedDate);
    const dateAfterNextDate = new Date(selectedDate);
    dateBeforePreviousDate.setDate(dateBeforePreviousDate.getDate() + -2);
    previousDate.setDate(previousDate.getDate() + -1);
    nextDate.setDate(nextDate.getDate() + 1);
		dateAfterNextDate.setDate(dateAfterNextDate.getDate() + 2);
		this.setState({
			dateBeforePreviousDate,
			previousDate,
			selectedDate,
			nextDate,
			dateAfterNextDate
		})
	}

	onDateChange = (date) => {
		let { userStore, sessionStore } = this.props;
		let { authUser } = sessionStore;
		this.modifyDates(date);
		userStore.fetchMeetings( authUser.uid, date);
	}

	meetingDetails = (uid) => {
		this.setState({
			meetingUid: uid
		},()=>{
				this.toggleSlider()
		})
	}

	getDayName = (val) => {
		return day[val];
	}

	getMonthName = (val) => {
		return month[val];
	}

	getTime = time => {
		var temp = time.split(" ");
		return (
			<span className="text-uppercase text-center font-small-2">
				{temp[0]}<br />
				{temp[1]}
			</span>
		)
	}

	renderMeetings = () => {
		const { todayMeetings } = this.props.dashboardStore;
		var hasMeetings = Object.keys(todayMeetings).length;
		if (hasMeetings) {
			return(
				<Fragment>
							<ul className="activity-timeline timeline-left list-unstyled">
						{
							Object.entries(todayMeetings).map(tm => {
								return (
									<li key={tm[0]} >
										<div 
										className="timeline-icon" 
										style={{ 
											left: "-4.6rem",
											backgroundColor: tm[1].endTime > new Date().getTime() ? "#7769f7" : "#cacaca"
										}}
									>
											{this.getTime(new Date(tm[1].startTime).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }).slice(0, 10))}
										</div>
										<div className="d-flex justify-content-between align-items-center flex-wrap">
											<div className="timeline-info">
												{
													tm[1].endTime > new Date().getTime()
														? <Link to={`/meeting/${tm[0]}`}>
																<p className="font-weight-bold mb-0 text-capitalize">{tm[1].presenter.displayName}</p>
															</Link>
														: <p style={{color: "#cacaca"}} className="font-weight-bold mb-0 text-capitalize">{tm[1].presenter.displayName}</p>
												}
												<p className="mb-0 text-capitalize">{tm[1].title}</p>
											</div>
											<div>
												{
													tm[1].endTime > new Date().getTime() ?
														(
															<Button disabled color="default" className="btn-icon ml-auto">
																<Calendar size={24} />
															</Button>
														) :
														(
															
																<Button onClick={()=>this.meetingDetails(tm[0])} color="default" className="btn-icon ml-auto">
																	<Calendar size={24} />
																</Button>
													
														)
												}
											</div>
										</div>
										
									</li>	
								)
							})
						}		
					</ul>
				</Fragment>
				
			)} else {
			return (
				<div className="d-flex justify-content-center align-items-center" style={{height: "100%"}}>
					<span className="text-muted">No appointements.</span>
				</div>
			)
		}
	}

	render() {
		const { todayMeetings } = this.props.dashboardStore;
		return (
			<div style={{height: "100%"}}>
				<div className="mb-2 d-flex justify-content-between align-items-center">
					<div>
						<Calendar size="20" strokeWidth="3" />
						<b style={{marginLeft: "5px"}}>{this.state.selectedDate ? this.getMonthName(this.state.selectedDate.getMonth()) : ""}</b>
					</div>
					<div>
						{
							new Date(this.state.selectedDate).toLocaleDateString() !== new Date().toLocaleDateString()
							? <span 
									style={{fontSize: "12px", cursor: "pointer"}}
									onClick={() => { this.onDateChange(new Date()) }}>
									<i>Today</i>
								</span>
							:	null
						}	
						{/* <ChevronLeft 
							strokeWidth="3" 
							onClick={() => this.onDateChange(this.state.previousDate)} 
							size={22}/>
						<Circle
							strokeWidth="3"
							fill="#7367f0"
							color="#7367f0"
							onClick={()=>{this.onDateChange(new Date())}}
							size={12} />
						<ChevronRight 
							strokeWidth="3" 
							onClick={() => this.onDateChange(this.state.nextDate)} 
							size={22} /> */}
					</div>
				</div>
				<div className="appointment_dates">
						<div className="d-flex justify-content-around align-items-center">
							<span
								className="dateBlock"
								onClick={() => this.onDateChange(this.state.dateBeforePreviousDate) } >
								{this.state.dateBeforePreviousDate ? this.getDayName(this.state.dateBeforePreviousDate.getDay()) : ""}<br />
								{this.state.dateBeforePreviousDate ? this.state.dateBeforePreviousDate.getDate() : ""}
								
							</span>
							<span
								className="dateBlock" 
								onClick={() => this.onDateChange(this.state.previousDate)} >
								{this.state.previousDate ? this.getDayName(this.state.previousDate.getDay()) : ""}<br />
								{this.state.previousDate ? this.state.previousDate.getDate() : ""}
							</span>
							<span
								className="selected dateBlock" 
								onClick={() => this.onDateChange(this.state.selectedDate)} >
								{this.state.selectedDate ? this.getDayName(this.state.selectedDate.getDay()) : ""}<br />
								{this.state.selectedDate ? this.state.selectedDate.getDate(): ""}
							</span>
							<span
								className="dateBlock" 
								onClick={() => this.onDateChange(this.state.nextDate)} >
								{this.state.nextDate ? this.getDayName(this.state.nextDate.getDay()) : ""}<br />
								{this.state.nextDate ? this.state.nextDate.getDate(): ""}
							</span>
							<span
								className="dateBlock" 
								onClick={() => this.onDateChange(this.state.dateAfterNextDate)} >
								{this.state.dateAfterNextDate ? this.getDayName(this.state.dateAfterNextDate.getDay()) : ""}<br />
								{this.state.dateAfterNextDate ? this.state.dateAfterNextDate.getDate(): ""}
							</span>
						</div>
					</div>
				<div style={{height: "100%"}}>
					{this.renderMeetings()}
				</div>

				{/*--------------Overlay-------------*/}
				<div className='animation-slider'>
					{
						this.state.sliderVisibility
							? <ScheduleMeetingWizard
								show={this.state.sliderVisibility}
								meetingId={this.state.meetingUid}
								onCreateSuccess={this.onCreateSuccess}
								toggleSliderVisibility={this.toggleSlider}
							/>
							: null
					}
					<div
						className={classnames("animation-slider-overlay", {
							show: this.state.sliderVisibility
						})}
						onClick={() => this.toggleSlider(false)}
					/>
				</div> 

			</div>
			
		)
	}
}

export default MeetingCard;


{/* <div className="d-flex justify-content-between align-items-center mb-1" key={tm[0]}>
	<div className="user-info d-flex align-items-center ml-2p">
		<div className="avatar mr-50">
			<img
				src={tm[1].participants[0].imageUrl ? tm[1].participants[0].imageUrl : img1}
				alt="avtar img holder"
				height="40"
				width="40"
			/>
		</div>
		<div className="user-page-info ml-10">
			<h5 className="mb-0">{tm[1].participants[0].displayName}</h5>
			<span className="font-small-2">{tm[1].title}</span>
		</div>
	</div>
	{
		tm[1].status === "END" ?
			(
				<h6 className="mr-4p">Meeting Over!</h6>
			) :
			(
				<Link to={`/meeting/${tm[0]}`} className="primary  mr-4p">
					<span className="font-small-4 mr-10">{new Date(tm[1].startTime).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }).slice(0, 10)}</span>
					<Button color="primary" className="btn-icon ml-auto">
						<Calendar size={17} />
					</Button>
				</Link>
			)
	}

</div>  */}



// <Card>
// 	<CardBody>
// 		<CardTitle>
// 			Today's Meeting
// 							<hr />
// 		</CardTitle>
// 		{today == null || today.length == 0 ? <p className="ml-4p font-italic">No Meeting for Today!</p> : today}
// 		<br />
// 		<CardTitle>
// 			Upcoming Meeting
// 							<hr />
// 		</CardTitle>
// 		{upcoming == null || upcoming.length == 0 ? <p className="ml-4p font-italic">No Upcoming Meeting for Now!</p> : upcoming}
// 	</CardBody>
// </Card>



// let upcoming = null
// upcoming = Object.entries(upcomingMeetings).map(um => {
// 	return (
// 		<div className="d-flex justify-content-between align-items-center mb-1" key={um[0]}>
// 			<div className="user-info d-flex align-items-center ml-2p">
// 				<div className="avatar mr-50">
// 					<img
// 						src={um[1].participants[0].imageUrl ? um[1].participants[0].imageUrl : img1}
// 						alt="avtar img holder"
// 						height="40"
// 						width="40"
// 					/>
// 				</div>
// 				<div className="user-page-info ml-10">
// 					<h5 className="mb-0">{um[1].participants[0].displayName}</h5>
// 					<span className="font-small-2">{um[1].title}</span>
// 				</div>
// 			</div>
// 			<div className="ml-auto mr-4p">
// 				<div className="align-items-right">
// 					<span className="font-small-3">{new Date(um[1].startTime).toDateString().slice(0, 10)}</span>
// 					<br />
// 					<span className="font-small-2 float-right">{new Date(um[1].startTime).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }).slice(0, 10)}</span>
// 				</div>
// 			</div>
// 		</div>
// 	)
// })
